<template>
  <div class="pagination-component">
    <div class="d-flex align-center justify-space-between pt-4 hidden-xs-only px-3">
      <div class="d-flex align-center pagination-block">
        <span class="ml-2">نمایش ردیف:</span>
        <v-text-field v-model="newPageSize" hide-details outlined rounded dense type="number" class="fotter-input"
          @keyup.enter="changePageSize()"
          oninput="if(Number(this.value) > 500) this.value = 500; if(Number(this.value) < 1) this.value = 1;" />
        <v-btn small fab class="mr-2" color="lightColor" elevation="0" @click="changePageSize()">
          <v-icon color="white">mdi-arrow-left-thin</v-icon>
        </v-btn>
      </div>

      <div class="d-flex align-center justify-center flex-grow-1" style="position: relative;top: -12px;">
        <slot name="action" />
      </div>

      <div class="d-flex align-center pagination-block">
        <span class="mx-3">کل: {{ totalRecords || 0 }}</span>
        <span class="mx-3">صفحه {{ page }} از {{ totalPages }}</span>
        <span class="ml-2">برو به:</span>
        <v-text-field v-model="newPage" :max="totalPages" hide-details outlined rounded dense type="number"
          class="fotter-input" @keyup.enter="changePage()"
          oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; if(Number(this.value) < 1) this.value = 1;" />
        <v-btn small fab class="mr-2" color="lightColor" elevation="0" @click="changePage()">
          <v-icon color="white">mdi-arrow-left-thin</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Mobile layout -->
    <div class="hidden-sm-and-up mt-5">
      <div class="text-center mb-4">
        <slot name="action" />
      </div>

      <div class="d-flex align-center justify-space-between">
        <!-- Rows-per-page picker -->
        <div class="d-flex align-center pagination-block-mobile">
          <span class="mobile-text ml-1">نمایش ردیف:</span>
          <v-text-field v-model="newPageSize" hide-details solo dense type="number" class="fotter-input"
            @keyup.enter="changePageSize()"
            oninput="if(Number(this.value) > 500) this.value = 500; if(Number(this.value) < 1) this.value = 1;" />
          <v-btn small class="mr-1" color="white" @click="changePageSize()">
            <v-icon color="#0D296E">mdi-arrow-left-thin</v-icon>
          </v-btn>
        </div>

        <!-- Totals + go to page -->
        <div class="d-flex align-center pagination-block-mobile">
          <span class="mobile-text">کل: {{ totalRecords || 0 }}</span>
          <v-divider vertical inset class="go-to-page-divider mx-2" />
          <span class="mobile-text">صفحه {{ page }}</span>
          <v-divider vertical inset class="go-to-page-divider mx-2" />
          <v-text-field v-model="newPage" :max="totalPages" hide-details solo dense type="number" class="fotter-input"
            @keyup.enter="changePage()"
            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; if(Number(this.value) < 1) this.value = 1;" />
          <v-btn small class="mr-1" color="white" @click="changePage()">
            <v-icon color="#0D296E">mdi-arrow-left-thin</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/Mixins/Pagination';

export default {
  name: 'PaginationComponent',
  mixins: [pagination],
  data() {
    return {};
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    refs() {
      return this.$root.$refs;
    },
  },
  created() {
    this.$root.$refs.paginationComponent = this;
  },
  methods: {
    // ============================
    // تغییر سایز صفحه
    // ============================
    changePageSize() {
      this.pageSize = Number(this.newPageSize);
      this.page = 1;
      this.newPage = 1;

      const route = this.routeName;
      const ref = this.refs;

      const handlers = {
        user: () => this.updateAndFetch(ref.UserManagment, 'getListOfUsersWithPagination'),
        hospital: () => this.updateAndFetch(ref.HospitalManagment, 'getListOfHospitalsWithPagination'),
        station: () => this.updateAndFetch(ref.StationManagment, 'getListOfStationsWithPagination'),
        otherOrganization: () => this.updateAndFetch(ref.OtherOrganizationManagment, 'getListOfOtherOrganizationsWithPagination'),
        chiefComplaint: () => this.updateAndFetch(ref.ChiefComplaintManagment, 'getListOfChiefComplaintsWithPagination'),
        drug: () => this.updateAndFetch(ref.DrugManagment, 'getListOfDrugsWithPagination'),
        disabledPeople: () => this.updateAndFetch(ref.DisabledPeopleManagment, 'getListOfDisabledPeoplesWithPagination'),
        vehicle: () => this.updateAndFetch(ref.VehicleManagment, 'getListOfVehiclesWithPagination'),
        phone: () => this.updateAndFetch(ref.PhoneManagment, 'getListOfPhonesWithPagination'),
        userGroup: () => this.updateAndFetch(ref.UserGroupManagment, 'getListOfUserGroupsWithPagination'),
        medicalItem: () => this.updateAndFetch(ref.MedicalItemManagment, 'getListOfMedicalItemsWithPagination'),
        tag: () => this.updateAndFetch(ref.TagManagment, 'getListOfTagsWithPagination'),
        flagData: () => this.updateAndFetch(ref.FlagDataManagment, 'getListOfFlagDatasWithPagination'),
        clientComputer: () => this.updateAndFetch(ref.ClientComputerManagment, 'getListOfClientComputersWithPagination'),
        missionReport: () => this.updateAndFetch(ref.MissionReport, 'getMissionReportfunction'),
        hospitalMissionReport: () => this.updateAndFetch(ref.HospitalMissionsReport, 'getListOfHospitalAdmissionsWithPaginationReportFunction'),
        customReportAmar: () => this.updateAndFetch(ref.CustomReportAmar, 'getListOfCustomReportsWithPagination'),
        QcCustomReport: () => this.updateAndFetch(ref.QcCustomReport, 'getListOfCustomReportsWithPagination'),
        qcSurveyReport: () => this.fetchQcSurveyReport(ref.QcSurveyReport),
        qcOnlineUsersReport: () => this.fetchQcOnlineUsersReport(ref.qcOnlineUsersReport),
        qcUsersLoginLogoutReport: () => this.fetchQcUsersLoginLogout(ref.QcUsersLoginLogoutReport),
        qcCallsReport: () => this.fetchQcCallsReport(ref.qcCallReport),
        qcMissionTimesReport: () => this.fetchQcMissionTimesReport(ref.qcMissionTimesReport),
        qcMissionFenceTimesReport: () => this.fetchQcMissionFenceTimesReport(ref.qcMissionFenceTimesReport),
        qcTechnicianPerformanceReport: () => this.fetchQcTechnicianPerformance(ref.qcTechnicianPerformanceReport),
        qcUsersForQCReport: () => this.fetchQcUsersForQC(ref.qcUsersForQCReport),
        user115AllLoginLogout: () => this.fetchUser115LoginLogout(ref.User115AllLoginLogout),
        user115AllCalls: () => this.fetchUser115Calls(ref.User115AllCalls),
        qcAllCheckLists: () => this.fetchQcAllCheckLists(ref.QcAllCheckListReport),
        qcDNDTimesReport: () => this.fetchQcDNDTimes(ref.QcUsersDNDsReport),
        phoneActivityReport: () => this.fetchPhoneActivity(ref.AmarCodeReport),
        refuelReportAmar: () => this.fetchRefuelReport(ref.AmarRefuelReport),
      };

      if (handlers[route]) {
        handlers[route]();
      }
    },

    // ============================
    // تغییر صفحه
    // ============================
    changePage() {
      this.page = this.newPage;
      const route = this.routeName;
      const ref = this.refs;

      const handlers = {
        user: () => this.updateAndFetch(ref.UserManagment, 'getListOfUsersWithPagination'),
        hospital: () => this.updateAndFetch(ref.HospitalManagment, 'getListOfHospitalsWithPagination'),
        station: () => this.updateAndFetch(ref.StationManagment, 'getListOfStationsWithPagination'),
        otherOrganization: () => this.updateAndFetch(ref.OtherOrganizationManagment, 'getListOfOtherOrganizationsWithPagination'),
        chiefComplaint: () => this.updateAndFetch(ref.ChiefComplaintManagment, 'getListOfChiefComplaintsWithPagination'),
        drug: () => this.updateAndFetch(ref.DrugManagment, 'getListOfDrugsWithPagination'),
        disabledPeople: () => this.updateAndFetch(ref.DisabledPeopleManagment, 'getListOfDisabledPeoplesWithPagination'),
        vehicle: () => this.updateAndFetch(ref.VehicleManagment, 'getListOfVehiclesWithPagination'),
        phone: () => this.updateAndFetch(ref.PhoneManagment, 'getListOfPhonesWithPagination'),
        userGroup: () => this.updateAndFetch(ref.UserGroupManagment, 'getListOfUserGroupsWithPagination'),
        medicalItem: () => this.updateAndFetch(ref.MedicalItemManagment, 'getListOfMedicalItemsWithPagination'),
        tag: () => this.updateAndFetch(ref.TagManagment, 'getListOfTagsWithPagination'),
        flagData: () => this.updateAndFetch(ref.FlagDataManagment, 'getListOfFlagDatasWithPagination'),
        clientComputer: () => this.updateAndFetch(ref.ClientComputerManagment, 'getListOfClientComputersWithPagination'),
        missionReport: () => this.updateAndFetch(ref.MissionReport, 'getMissionReportfunction'),
        hospitalMissionReport: () => this.updateAndFetch(ref.HospitalMissionsReport, 'getListOfHospitalAdmissionsWithPaginationReportFunction'),
        customReportAmar: () => this.updateAndFetch(ref.CustomReportAmar, 'getListOfCustomReportsWithPagination'),
        QcCustomReport: () => this.updateAndFetch(ref.QcCustomReport, 'getListOfCustomReportsWithPagination'),
        qcSurveyReport: () => this.fetchQcSurveyReport(ref.QcSurveyReport),
        qcOnlineUsersReport: () => this.fetchQcOnlineUsersReport(ref.qcOnlineUsersReport),
        qcUsersLoginLogoutReport: () => this.fetchQcUsersLoginLogout(ref.QcUsersLoginLogoutReport),
        qcCallsReport: () => this.fetchQcCallsReport(ref.qcCallReport),
        qcMissionTimesReport: () => this.fetchQcMissionTimesReport(ref.qcMissionTimesReport),
        qcMissionFenceTimesReport: () => this.fetchQcMissionFenceTimesReport(ref.qcMissionFenceTimesReport),
        qcTechnicianPerformanceReport: () => this.fetchQcTechnicianPerformance(ref.qcTechnicianPerformanceReport),
        qcUsersForQCReport: () => this.fetchQcUsersForQC(ref.qcUsersForQCReport),
        user115AllLoginLogout: () => this.fetchUser115LoginLogout(ref.User115AllLoginLogout),
        user115AllCalls: () => this.fetchUser115Calls(ref.User115AllCalls),
        qcAllCheckLists: () => this.fetchQcAllCheckLists(ref.QcAllCheckListReport),
        qcDNDTimesReport: () => this.fetchQcDNDTimes(ref.QcUsersDNDsReport),
        phoneActivityReport: () => this.fetchPhoneActivity(ref.AmarCodeReport),
        refuelReportAmar: () => this.fetchRefuelReport(ref.AmarRefuelReport),
      };

      if (handlers[route]) {
        handlers[route]();
      }
    },

    updateAndFetch(ref, method) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      if (typeof ref[method] === 'function') {
        ref[method]();
      }
    },

    fetchQcSurveyReport(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCSurveyReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchMissionId,
        ref.searchSurveyCategoryId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcOnlineUsersReport(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCOnlineUsersReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchRoleId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcUsersLoginLogout(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCUsersLoginLogoutReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchUserId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcCallsReport(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCCallsReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchCallTagId,
        null,
        ref.searchDestination,
        ref.searchUserId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcMissionTimesReport(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCMissionTimesReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchFirstUserId,
        ref.searchSecondUserId,
        ref.searchPhoneCode,
        ref.searchVehicleTypeId,
        ref.searchCityId,
        ref.searchDispatchTillMoveMinimumSecond,
        ref.searchDispatchTillMoveMinimumMinute,
        ref.searchMoveTillArriveMinimumSecond,
        ref.searchMoveTillArriveMinimumMinute,
        ref.searchPatientWaitingDurationMinimumSecond,
        ref.searchPatientWaitingDurationMinimumMinute,
        ref.searchHospitalWaitingDurationMinimumSecond,
        ref.searchHospitalWaitingDurationMinimumMinute,
        ref.searchMissionDurationMinimumSecond,
        ref.searchMissionDurationMinimumMinute,
        ref.searchMissionDurationMinimumHoure,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcMissionFenceTimesReport(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCMissionFenceTimesReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchFirstUserId,
        ref.searchSecondUserId,
        ref.searchPhoneCode,
        ref.searchVehicleTypeId,
        ref.searchCityId,
        ref.searchDispatchTillMoveMinimumSecond,
        ref.searchDispatchTillMoveMinimumMinute,
        ref.searchMoveTillArriveMinimumSecond,
        ref.searchMoveTillArriveMinimumMinute,
        ref.searchPatientWaitingDurationMinimumSecond,
        ref.searchPatientWaitingDurationMinimumMinute,
        ref.searchHospitalWaitingDurationMinimumSecond,
        ref.searchHospitalWaitingDurationMinimumMinute,
        ref.searchMissionDurationMinimumSecond,
        ref.searchMissionDurationMinimumMinute,
        ref.searchMissionDurationMinimumHoure,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcTechnicianPerformance(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCTechnicianPerformancePaginationReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchCityId,
        ref.searchUserId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcUsersForQC(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCUsersForQCReportFunction(
        ref.searchFullName,
        ref.searchRoleId,
        ref.searchNationalCode,
        ref.page,
        ref.pageSize,
      );
    },

    fetchUser115LoginLogout(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCUsersLoginLogoutReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.userId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchUser115Calls(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getQCCallsReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        null,
        null,
        null,
        ref.userId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcAllCheckLists(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getListOfCheckListsWithPaginationFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchVehicleId,
        ref.searchSeniorTechnicianId,
        ref.searchPreviousSeniorTechnicianId,
        ref.searchDrugId,
        ref.searchNotSelectedCategoryItemId,
        ref.searchIsActive,
        ref.page,
        ref.pageSize,
      );
    },

    fetchQcDNDTimes(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getUsersDNDsWithPaginationFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchUserId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchPhoneActivity(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getAmarCodeReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchPhoneId,
        ref.searchCityId,
        ref.searchVehicleTypeId,
        ref.page,
        ref.pageSize,
      );
    },

    fetchRefuelReport(ref) {
      if (!ref) return;
      ref.page = Number(this.page);
      ref.newPage = Number(this.newPage);
      ref.pageSize = Number(this.pageSize);
      ref.getAmarRefuelReportFunction(
        ref.searchFromDate,
        ref.searchToDate,
        ref.searchPhoneId,
        ref.searchVehicleId,
        ref.searchUserId,
        ref.searchMinimumLiter,
        ref.searchCityId,
        ref.page,
        ref.pageSize,
      );
    },
  },
};
</script>

<style scoped>
/* ------ layout helpers ------ */
.pagination-block {
  min-width: 0;
}

.pagination-block .fotter-input {
  max-width: 90px;
}

.pagination-block-mobile .fotter-input {
  max-width: 70px;
}

.go-to-page-divider {
  height: 5vh;
}

.mobile-text {
  font-size: 10px !important;
}

/* ------ input styling ------ */
>>>.fotter-input input {
  font-size: 11px !important;
  padding: 0 !important;
  text-align: center;
}

/* ------ v-pagination styling ------ */
>>>.v-pagination .v-pagination__navigation {
  box-shadow: none !important;
  background: none !important;
}

>>>.v-pagination__item {
  font-size: 13px !important;
  font-weight: bold !important;
  box-shadow: none !important;
  background: transparent !important;
}

>>>.v-pagination__navigation {
  box-shadow: none !important;
  border-radius: 50% !important;
  background-color: #8e8e8e !important;
}

>>>.v-pagination__navigation--disabled {
  background-color: transparent !important;
}

>>>.v-pagination__navigation--disabled .mdi-chevron-right,
>>>.v-pagination__navigation--disabled .mdi-chevron-left {
  background-color: transparent !important;
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  color: #0d296e;
}

>>>.v-pagination__navigation--disabled .mdi-chevron-right {
  margin-right: -8px;
}

>>>.v-pagination__navigation--disabled .mdi-chevron-left {
  margin-left: -8px;
}
</style>